import { FileDownload } from "@mui/icons-material";
import { Menu, MenuItem } from "@mui/material";
import { ExportCsv, type GridCsvExportOptions } from "@mui/x-data-grid-premium";
import React, { useRef, useState } from "react";
import { TableToolbarButton } from "./TableToolbarButton";

export default function ToolbarExportButton({
  csvOptions,
}: {
  csvOptions?: GridCsvExportOptions;
}) {
  const [exportMenuOpen, setExportMenuOpen] = useState(false);
  const exportMenuTriggerRef = useRef<HTMLButtonElement>(null);

  return (
    <>
      <TableToolbarButton
        ref={exportMenuTriggerRef}
        id="export-menu-trigger"
        aria-controls="export-menu"
        aria-haspopup="true"
        aria-expanded={exportMenuOpen ? "true" : undefined}
        onClick={() => setExportMenuOpen(true)}
        startIcon={<FileDownload />}
      >
        Export
      </TableToolbarButton>
      <Menu
        id="export-menu"
        anchorEl={exportMenuTriggerRef.current}
        open={exportMenuOpen}
        onClose={() => setExportMenuOpen(false)}
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
        transformOrigin={{ vertical: "top", horizontal: "right" }}
        slotProps={{
          list: {
            "aria-labelledby": "export-menu-trigger",
          },
        }}
      >
        <ExportCsv
          render={<MenuItem />}
          onClick={() => setExportMenuOpen(false)}
          options={csvOptions}
        >
          Download as CSV
        </ExportCsv>
      </Menu>
    </>
  );
}
